import { fetcher } from '#lib/backendFetcher';

/**
 * Sends a test email to a specified address.
 * @param {Object} body - Send data (recipient, subject, content, etc.)
 * @returns {Promise<Object>}
 */
export const sendTestEmail = (body) => fetcher('/api/v1/email/sender/send-test', { method: 'POST', body });
